import React from 'react';
import { motion } from 'framer-motion';
const contents = [{
  n: '01',
  title: 'Introducción al falso vitral',
  desc: 'Qué es la técnica, qué piezas puedes crear y cómo empezar aunque no tengas experiencia.'
}, {
  n: '02',
  title: 'Materiales sin complicarte',
  desc: 'Qué comprar, qué usar, qué evitar y cómo armar tu kit inicial sin gastar de más.'
}, {
  n: '03',
  title: 'Preparación de la superficie',
  desc: 'Cómo limpiar, fijar la plantilla y dejar el vidrio listo para trabajar sin marcas.'
}, {
  n: '04',
  title: 'Delineado y contornos',
  desc: 'El trazo que define la pieza: pulso, presión y cómo lograr líneas parejas.'
}, {
  n: '05',
  title: 'Color, relleno y secado',
  desc: 'Cómo combinar colores, rellenar sin burbujas y respetar los tiempos de secado.'
}, {
  n: '06',
  title: 'Errores comunes y soluciones',
  desc: 'Manchas, pintura corrida y contornos irregulares: cómo corregirlos y evitarlos.'
}];
export function GuideContents() {
  return <section className="bg-deco-beige py-14 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-90" data-mp="iaqlr2nagkee">
      <div className="max-w-5xl mx-auto" data-id="element-91" data-mp="n8s75u86svt1">
        <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-14 items-center mb-14" data-id="element-92" data-mp="n9tqsn39qqmd">
          <motion.img initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} src="https://cdn.magicpatterns.com/uploads/5ZEQHW6jVRusR4SPDtc3Ge/MOCK_UP_FALSO_VITRAL.png" alt="Guía Falso Vitral Deco" className="w-full max-w-xs mx-auto object-contain drop-shadow-2xl" data-id="element-93" data-mp="s9g5l0yqwexa" />

          <div className="text-center lg:text-left" data-id="element-94" data-mp="1fyqyjw9ut50v">
            <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-4" data-id="element-95" data-mp="1jz163ddao3hu">
              La guía principal
            </p>
            <h2 className="font-serif text-2xl sm:text-4xl text-deco-forest font-semibold leading-snug mb-5" data-id="element-96" data-mp="3l0h48uveke5v">
              Todo lo que incluye{' '}
              <span className="italic text-deco-brick" data-id="element-97" data-mp="3h06z1kffprs2">Falso Vitral Deco</span>
            </h2>
            <p className="text-sm text-deco-forest/65 leading-relaxed max-w-md mx-auto lg:mx-0" data-id="element-98" data-mp="3urc10t69yw5k">
              Un recorrido simple y práctico en seis partes: desde qué
              materiales conseguir hasta cómo corregir los errores más comunes
              para que tus piezas se vean prolijas y vendibles.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-99" data-mp="hjs69x9vycrt">
          {contents.map((c, i) => <motion.div key={c.n} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-deco-cream rounded-2xl p-6 border border-deco-aqua/30" style={{
          backgroundColor: "#FFFCF9",
          backgroundImage: "none"
        }} data-id="element-100" data-mp="ckfldi2krfrv" data-mpi={i}>
              <span className="block font-serif text-xl text-deco-aqua mb-3" data-id="element-101" data-mp="yt33ch6u1rv9">
                {c.n}
              </span>
              <h3 className="font-serif text-base sm:text-lg text-deco-forest font-semibold leading-snug mb-2" data-id="element-102" data-mp="l2hl8up7dlyf">
                {c.title}
              </h3>
              <p className="text-[13px] text-deco-forest/60 leading-relaxed" data-id="element-103" data-mp="p16y8m6bx1hj">
                {c.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}